export default "skymp5-front/718d2b5150d312f67f5b3a1de7d9e879.png";